/* eslint-disable @typescript-eslint/no-explicit-any */
/** @format */

export const handleApiError = (error: any): string => {
  if (import.meta.env.MODE !== "production") {
    console.warn("[Fetch Error...]", error);
  }

  if (error && typeof error === "object" && "status" in error) {
    switch (error.status) {
      case 400:
        return "Bad Request";
      case 401:
        return "Unauthorized User!";
      case 403:
        return "Forbidden";
      case 404:
        return "Resource not found";
      case 409:
        return "A duplicate already exists";
      case 422:
        return "Unprocessable Entity";
      case 500:
        return "Server Error";
      default:
        return error.message || "Something went wrong";
    }
  }

  return typeof error === "string" ? error : "Unexpected error occurred";
};
